import { rm, NO_ELEMENT, hasElements } from 'utils';
import { Faq as FaqModel } from 'models/Faq';
import styles from './faqContainer.scss';
import { CategoryFaqs } from 'views/ProductPage/faqs/themes/BGH';

interface OwnProps {
  faqs?: FaqModel[];
  totalNumberOfFaqs: number;
}

export const FaqContainer = ({ faqs, totalNumberOfFaqs }: OwnProps) => {
  if (!faqs || !hasElements(faqs)) {
    return NO_ELEMENT;
  }

  return (
    <div className={styles.faqBlock}>
      <CategoryFaqs
        faqs={faqs}
        totalNumberOfFaqs={totalNumberOfFaqs}
        title={rm('product_faq_header')}
        phoneSize="1"
        tabletSize="2"
      />
    </div>
  );
};
